import React from "react";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Avatar,
  Typography,
  TextField,
  Button,
  useMediaQuery,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Person } from "@mui/icons-material";
import { GlassDialog, dialogTransitionProps } from "../../../theme/theme";

export function UserDialog({
  open,
  onClose,
  theme,
  darkMode,
  newUser,
  setNewUser,
  addUser,
}) {
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <GlassDialog open={open} onClose={onClose} maxWidth="sm" fullWidth fullScreen={fullScreen} {...dialogTransitionProps}>
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Avatar sx={{ bgcolor: alpha(theme.palette.secondary.main, 0.1), width: 48, height: 48 }}>
            <Person color="secondary" />
          </Avatar>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, color: darkMode ? '#EAF3FB' : '#0E1B2C' }}>
              Add New User
            </Typography>
            <Typography variant="caption" sx={{ color: darkMode ? '#93A2BC' : 'text.secondary' }}>
              Create a new user account
            </Typography>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        <TextField
          fullWidth
          label="Username"
          margin="normal"
          value={newUser.username}
          onChange={(e) => setNewUser({ ...newUser, username: e.target.value })}
          placeholder="Enter username"
        />
        <TextField
          fullWidth
          label="Password"
          type="password"
          margin="normal"
          value={newUser.password}
          onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
          placeholder="Enter password"
        />
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={addUser} variant="contained" sx={{ px: 4 }}>
          Create User
        </Button>
      </DialogActions>
    </GlassDialog>
  );
}

export default UserDialog;
